import TableList from './TableList.vue'

TableList.install = app => {
  app.component(TableList.name, TableList)
}

export default TableList
